import React from "react";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";


export const Logo: React.FC = () => {
    const {t} = useTranslation();

    return (
        <div className="flex justify-center">
            <Link to="/">
                <img src="/images/fastype_blanc.png" alt={t("global.logo")} className="w-28"/>
            </Link>
        </div>
    )
}
